module.exports = "#content-wrapper {\n    margin-top: 50px;\n}"